var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",attrs:{"id":"app"}},[_c('page-header'),_c('keep-alive',{attrs:{"include":['Home','Featured','Travels']}},[_c('router-view')],1),_c('page-footer'),_c('el-backtop',[_c('i',{staticClass:"el-icon-caret-top"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }